import storage from './storage'

import { countries } from '@config/translation'

export const isClient = typeof window !== 'undefined'
export const country = isClient
  ? window.location.pathname.replace(/^\/|\/$/g, '').split('/')[0]
  : null
export const locale = storage.get('locale')
export const setUserToken = (userToken) => {
  storage.set('userToken', userToken)
}
// export const defaultLanguage = countries[country]?.defaultLanguage
export const defaultLanguage = 'id'